export default "__VITE_ASSET__FXAReSNv__"